import React, { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Container, Button } from 'reactstrap';
import Header from '../../component/Header';
import { AppContext } from '../../context/app-context';
import { msgAlert } from '../../helper';
import { useDiet } from '../../hooks/useDiet';
import DeviceBox from './DeviceBox';
import { sendFirebaseEvent } from '../../helper/mobile'; 

const SelectDevice = () => {
  const { type } = useParams();
  const { makeDietPayment } = useDiet();
  const [state, dispatch] = useContext(AppContext);
  const [selectedDevice, setSelectedDevice] = useState([]);
  const [showDevice, setShowDevice] = useState(state.deviceList);
  const [dietPlan, setDietPlan] = useState();

  useEffect(() => {
    if(type === 'one_month_diet_plan')
      setShowDevice(state.deviceList.filter(obj => obj.productId !== 'smartWatch8002'))

    setDietPlan(state.dietPlans.find(obj => obj.dietPlanType === type));
  }, [type]);


  const deviceCheckboxHandler = e => {
    const isChecked = e.target.checked;
    if(isChecked){
      setSelectedDevice([...selectedDevice, e.target.value]);
    }else {
      let index = selectedDevice.indexOf(e.target.value);
      selectedDevice.splice(index, 1);
      setSelectedDevice(selectedDevice);
    }
  }

  const dietPayment = () => {

    const prodInc = state.deviceList.filter(obj => selectedDevice.find(o => o === obj.productId));
    const request = {
      "userId":state.user.userId,
      "groupId":state.user.groupId,
      "appVersion":state.user.appVersion,
      "osType":state.user.osType,
      "dietPlanType":dietPlan?.dietPlanType,
      "productsIncluded":prodInc
    }

    if(prodInc.length === dietPlan?.numberOfDevice ) {
//       sendFirebaseEvent('diet_plan_make_payment_click', 'click_event', dietPlan.dietPlanType);
      makeDietPayment(request);
    }
    else
      msgAlert(`Select any ${dietPlan?.numberOfDevice} device${dietPlan?.numberOfDevice > 1 ? 's' : ''}`, `This plan provide you with only ${dietPlan?.numberOfDevice} free device${dietPlan?.numberOfDevice > 1 ? 's' : ''}`, true, true);

  }
  return(
    <>
      {dietPlan && <Header title={`Select any ${dietPlan?.numberOfDevice} device${dietPlan?.numberOfDevice > 1 ? 's' : ''}`} /> }
      <Container className="diet-container pt-4 mb-6-rem">
        { showDevice && showDevice.map(obj => <DeviceBox key={obj.productId} device={obj} totalSelectedDevice={dietPlan?.numberOfDevice} selectedDevice={selectedDevice} deviceCheckboxHandler={deviceCheckboxHandler} /> ) }
      </Container>
      <div className="floating-btn-div"><Button className='diet-payment-btn btn-diet-done' onClick={dietPayment} >Make payment</Button></div>
    </>
  );
}

export default SelectDevice;
